import { OrderResponseDto } from '@planning/app/api'
import { nnrOrderService } from '@planning/services'
import { Event, IEvent, IQueryHandler, IQueryMessage } from '@tom-ui/utils'

export class GetOrdersByNnrOrderIdsQuery implements IQueryMessage {
  static type = 'GetOrdersByNnrOrderIdQuery'
  type = GetOrdersByNnrOrderIdsQuery.type

  constructor(public nnrOrderIds: number[]) {}

  getKey = () => {
    return JSON.stringify(this)
  }
}

export const getOrdersByNnrOrderIdsQueryHandler: IQueryHandler<
  GetOrdersByNnrOrderIdsQuery,
  IEvent<OrderResponseDto[]>
> = async query => {
  const data = await nnrOrderService.getOrdersByNnrOrderIds(query.nnrOrderIds)

  return new Event(GetOrdersByNnrOrderIdsQuery.type, data)
}
